/**
 * 工作流配置实体
 * zxw
 * 创建时间 2026-02-06
 */

import '../../css/app.css';
import CNF from '../../incs/Config';
import {
    StartIcon,
    EndIcon,
    LLMIcon,
    MCPIcon,
    APIIcon,
} from '../../incs/Icons';
import {
    winHeight,
    winWidth,
    GenerateNodeId,
    CopyToClipboard,
    rootReactDom,
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper';
import { IDIcon, ZoomFitIcon } from '../../incs/Icons';

import { useState, useRef, useEffect, } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    theme,
    message,
    Flex,
    Space,
    Button,
    Typography,
    Tooltip,
    FloatButton,
    Avatar,
    Dropdown,
    Divider,
    Tag,
} from 'antd';
import {
    ArrowLeftOutlined,
    FileTextOutlined,
    SaveOutlined,
    EllipsisOutlined,
    CopyOutlined,
    DeleteOutlined,
    ZoomOutOutlined,
    ZoomInOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
} from '@ant-design/icons';

import { Graph, Dnd, Shape } from '@antv/x6';
import { register } from '@antv/x6-react-shape';
import { registerSerializableComponent, serializeGraph, deserializeGraph } from '../../components/X6serializer';

import StartNodeEntity from './StartNodeEntity';    // 开始节点
import EndNodeEntity from './EndNodeEntity';        // 结束节点
import LLMNodeEntity from './LLMNodeEntity';        // 大模型节点
import MCPNodeEntity from './MCPNodeEntity';        // MCP节点
import APINodeEntity from './APINodeEntity';        // MCP节点

import AppReleaseEntity from '../appTemplate/AppReleaseEntity';

const { Text, Title, } = Typography;

// 拖拽节点
const DRAG_WIDTH = 200
const DRAG_HEIGHT = 32

// 放置节点
const DROP_WIDTH = 220
const DROP_HEIGHT = 40


// 注册React组件
registerSerializableComponent('StartIcon', StartIcon);
registerSerializableComponent('EndIcon', EndIcon);
registerSerializableComponent('LLMIcon', LLMIcon);
registerSerializableComponent('MCPIcon', MCPIcon);
registerSerializableComponent('APIIcon', APIIcon);

const AppWorkFlow = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorBgBase,
            colorBgSolid,
            colorBgActive,
            colorTextBase,
            colorGraphBg,
            colorBgContent,
            colorDanger,
            fontSizeSM,
            fontSizeLG,
            colorBgContainer,
            colorBgElevated,

        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const graphRef = useRef(null);
    const [graph, setGraph] = useState(null);
    const [dnd, setDnd] = useState(null);
    const [currentZoom, setCurrentZoom] = useState(1);
    const [currentNodeId, setCurrentNodeId] = useState(''); // 当前节点Id

    const [appInfo, setAppInfo] = useState(null);    // 应用信息
    const [isFullScreen, setIsFullScreen] = useState(false); // 是否全屏

    /**
     * 渲染节点模型信息
     * @param {*} node 
     */
    const renderNodeModal = (node) => {
        const nodeType = node.id.split('_')[0];
        if (nodeType === 'Start') {
            rootReactDom && rootReactDom.render(
                <StartNodeEntity
                    open={true}
                    node={node}
                    graph={graph}
                />)
        } else if (nodeType === 'End') {
            rootReactDom && rootReactDom.render(
                <EndNodeEntity
                    open={true}
                    node={node}
                    graph={graph}
                    colorPrimary={colorPrimary}
                    colorPrimaryBg={colorPrimaryBg}
                    colorTextBase={colorTextBase}
                />)
        } else if (nodeType === 'LLM') {
            rootReactDom && rootReactDom.render(
                <LLMNodeEntity
                    open={true}
                    node={node}
                    graph={graph}
                    colorPrimary={colorPrimary}
                    colorPrimaryBg={colorPrimaryBg}
                    colorTextBase={colorTextBase}
                />)
        } else if (nodeType === 'MCP') {
            rootReactDom && rootReactDom.render(
                <MCPNodeEntity
                    open={true}
                    node={node}
                    graph={graph}
                    colorPrimary={colorPrimary}
                    colorPrimaryBg={colorPrimaryBg}
                    colorTextBase={colorTextBase}
                />)
        } else if (nodeType === 'API') {
            rootReactDom && rootReactDom.render(
                <APINodeEntity
                    open={true}
                    node={node}
                    graph={graph}
                    colorPrimary={colorPrimary}
                    colorPrimaryBg={colorPrimaryBg}
                    colorTextBase={colorTextBase}
                />)
        }
    }

    /**
    * 渲染发布应用信息
    * @returns 
    */
    const renderAppReleaseEnity = () => {
        rootReactDom && rootReactDom.render(
            <AppReleaseEntity
                open={true}
                record={appInfo}
            />
        );
    }

    /**
     * 拖拽节点
     * @param {*} node 
     * @returns 
     */
    const AppDragNode = (node) => {
        const data = node.node.store.data?.data
        return <Space style={{
            width: DRAG_WIDTH,
            height: DRAG_HEIGHT,
            background: colorBgActive,
            paddingLeft: '4px',
            borderRadius: 8,
            border: `1px solid ${colorBgSolid}`,
            cursor: 'grab',

        }}>
            <Avatar size='small' shape='square' icon={data?.icon} style={{ background: data?.theme, }} />
            <Text style={{ color: colorTextBase, }}>{data?.title}</Text>
        </Space>
    }

    /**
     * 放置节点
     * @param {*} node 
     * @returns 
     */
    const AppDropNode = ({ node }) => {
        const [isHovered, setIsHovered] = useState(false);

        // 获取节点数据
        const data = node.getData();
        // 当前节点是否被选中
        const isSelected = data?.isSelected;

        let items = [];
        // 开始与结束节点不支持复制与删除
        if (!(data.key === 'Start' || data.key === 'End')) {
            items.push({
                key: 'copy',
                label: <Button color='default' variant='link' size='small' style={{ color: colorTextBase, fontSize: fontSizeSM, padding: 0 }} icon={<CopyOutlined />}>复制</Button>,
            });
            items.push({
                key: 'delete',
                label: <Button color='default' variant='link' size='small' style={{ color: colorDanger, fontSize: fontSizeSM, padding: 0 }} icon={<DeleteOutlined />}>删除</Button>,
            });
            items.push({
                type: 'divider',
            });
        }
        items.push({
            key: 'id',
            label: <Space>
                <Tag size='small' icon={<IDIcon />} style={{ color: colorTextBase, fontSize: fontSizeSM }}>{node.id}</Tag>
                <Button color='default' variant='text' size='small' icon={<CopyOutlined />} style={{ color: colorTextBase, fontSize: fontSizeSM }}
                    onClick={() => {
                        // 复制节点Id
                        CopyToClipboard(node.id);
                    }} />
            </Space>,
        });

        return <ConfigProvider theme={{
            token: {
                colorBgContainer: colorBgContainer,
                colorBgElevated: colorBgElevated,
            },
        }}>
            <div
                style={{
                    width: DROP_WIDTH,
                    height: DROP_HEIGHT,
                    display: 'flex',
                    alignItems: 'center',
                    background: colorBgContent,
                    borderRadius: 8,
                    border: `1px solid`,
                    borderColor: isSelected ? colorPrimary : colorBgSolid,
                    cursor: 'pointer',
                    boxShadow: isHovered || isSelected ? '0 0 15px rgba(0, 0, 0, 0.08)' : '',
                }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCurrentNodeId(node.id);
                }}
                onDoubleClick={(e) => {
                    e.preventDefault();
                    if (e.target.tagName === 'DIV' || (e.target.tagName === 'SPAN' && e.target.children.length === 0)) renderNodeModal(node);
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Space style={{ margin: '4px 10px', }}>
                    <Avatar size='small' shape='square' icon={data?.icon} style={{ background: data?.theme, }} />
                    <Flex>
                        <Text style={{ color: colorTextBase, width: 144, }}>{data?.title}</Text>
                        <Space style={{ justifyContent: 'flex-end' }}>
                            <Dropdown
                                menu={{
                                    items, onClick: ({ key }) => {
                                        // 复制节点
                                        if (key === 'copy') {
                                            // 取消所有选中节点
                                            cancelSelectedNodeAll(graph);
                                            // 点击画布空白处时，清空选中状态
                                            graph.cleanSelection();
                                            // 获取所有节点
                                            const nodes = graph.getNodes();
                                            // 获取当前节点类型数量
                                            const nodeCount = nodes.filter(n => n.id.split('_')[0] === node.id.split('_')[0]).length;
                                            // 生成节点Id
                                            const nodeId = GenerateNodeId(node.id.split('_')[0]);
                                            const nodeJson = node.toJSON();
                                            const newNode = graph.addNode({
                                                ...nodeJson,
                                                id: nodeId,
                                                position: {
                                                    x: nodeJson.position.x + (DROP_WIDTH * 3 / 2),
                                                    y: nodeJson.position.y,
                                                },
                                                data: {
                                                    ...data,
                                                    title: CNF.nodeConfig[node.id.split('_')[0].toLowerCase()].title + (nodeCount + 1),
                                                }
                                            });
                                            // 将复制节点设置为选中节点
                                            newNode.setData({
                                                isSelected: true,
                                            });
                                            // 将其设置为选中状态
                                            graph.select(newNode);
                                            setCurrentNodeId(nodeId);
                                        }
                                        // 删除节点
                                        else if (key === 'delete') {
                                            graph.removeNode(node);
                                        }
                                    }
                                }}
                                placement='bottomRight'
                                trigger={['click']}
                            >
                                <Button style={{ color: colorTextBase }} color='default' variant='text' size='small' icon={<EllipsisOutlined />} />
                            </Dropdown>
                        </Space>
                    </Flex>
                </Space>
            </div>
        </ConfigProvider>
    }

    // 注册拖拽节点
    register({
        shape: 'app-drag-node',
        width: DRAG_WIDTH,
        height: DRAG_HEIGHT,
        component: AppDragNode,
    });

    // 注册放置节点
    register({
        shape: 'app-drop-node',
        width: DROP_WIDTH,
        height: DROP_HEIGHT,
        effect: ['data'],
        component: AppDropNode,
        ports: {    // 定义节点左右连接桩样式
            groups: {
                left: {
                    position: 'left',
                    attrs: {
                        circle: {
                            magnet: true,
                            stroke: colorPrimary,
                            r: 4,
                        },
                    },
                },
                right: {
                    position: 'right',
                    // 同时渲染圆形和文本
                    attrs: {
                        circle: {
                            magnet: true,
                            stroke: colorPrimary,
                            r: 4,
                        },
                        // text: {
                        //     fontSize: 14,
                        //     text: '+',                // 加号
                        //     fill: '#fff',           // 白色
                        //     visibility: 'hidden',     // 默认隐藏
                        //     x: 19.5,
                        //     y: 0,
                        //     textAnchor: 'middle',
                        // },
                    },

                },
            },
        },
    });

    /**
     * 开始拖拽节点
     * 鼠标按下时触发
     * @param {*} e 
     */
    const startDrag = (e) => {
        const target = e.currentTarget;
        const nodeType = target.getAttribute('data-type');
        const nodeConfig = CNF.nodeConfig[nodeType];

        // 获取所有节点
        const nodes = graph.getNodes();
        // 获取当前节点类型数量
        const nodeCount = nodes.filter(n => n.id.split('_')[0].toLowerCase() === nodeType).length;
        const node = graph.createNode({
            id: GenerateNodeId(nodeConfig.key),
            shape: 'app-drag-node',
            data: {
                ...nodeConfig,
                title: nodeConfig.title + (nodeCount + 1),
            },
        });

        // 开始拖拽时调用
        dnd.start(node, e.nativeEvent);
    }

    /**
     * 取消所有选中节点
     * @param {*} graph 
     */
    const cancelSelectedNodeAll = (graph) => {
        graph.getNodes().forEach(node => {
            node.setData({ isSelected: false });
        });
    }

    // 初始化画布
    useEffect(() => {
        // 初始化
        if (!graphRef.current) return;

        // 创建画布
        const graph = new Graph({
            container: graphRef.current,
            width: isFullScreen ? winWidth : winWidth - 240,
            height: winHeight - CNF.menuHeight,
            grid: true,
            background: {
                color: colorGraphBg,
            },
            mousewheel: {   // 鼠标滚轮缩放
                enabled: true,
                global: true,
                modifiers: ['ctrl', 'meta'],
                zoomAtMousePosition: true,
                factor: 1.2,
                maxScale: 2,
                minScale: 0.5,
            },
            connecting: {
                snap: true, // 吸附效果
                allowBlank: false,
                highlight: true,
                allowLoop: false,   // 禁止创建循环连线（同一节点）
                allowNode: false,   // 禁止连接到节点本身（必须通过连接桩）
                allowMulti: 'withPort', // 禁止在相同连接桩之间创建多条边
                connector: {
                    name: 'smooth',
                },
                createEdge() {
                    return new Shape.Edge({
                        attrs: {
                            line: {
                                stroke: '#9A98A4',    // 默认线条颜色为红色
                                strokeWidth: 1,         // 线条粗细
                            },
                        },
                    });
                },
                // 连接桩校验规则
                validateConnection({ sourceCell, targetCell, sourcePort, targetPort }) {
                    // 如果源或目标不是节点，则不允许连接（可根据需要调整）
                    // if (!sourceCell || !targetCell || !(sourceCell instanceof Node) || !(targetCell instanceof Node)) {
                    //     return false
                    // }

                    // 获取源连接桩和目标连接桩所在的组
                    const sourcePortGroup = sourceCell.getPort(sourcePort)?.group
                    const targetPortGroup = targetCell.getPort(targetPort)?.group

                    // 必须满足：源连接桩属于 right 组，目标连接桩属于 left 组
                    return sourcePortGroup === 'right' && targetPortGroup === 'left'
                },
            },
        });

        // 拖拽交互
        const dnd = new Dnd({
            target: graph,
            scaled: false,
            getDragNode: (node) => node.clone({ keepId: true }), // 这样放置到画布上的节点 ID 和 dnd start 传入的 node ID 一致
            getDropNode: (node) => node.clone({ keepId: true }),
            getDropNode: (node) => {
                const nodeConfig = node.clone().store.data.data;
                return graph.createNode({
                    id: GenerateNodeId(nodeConfig.key),
                    shape: 'app-drop-node',
                    data: nodeConfig,
                    ports: {
                        items: [
                            {
                                group: 'left',
                            },
                            {
                                group: 'right',
                            },
                        ],
                    },
                });
            },

        });

        /**
         * 根据边的方向进行拓扑排序
         * @param {Array} nodes - 节点数组，每个元素需包含 id 属性
         * @param {Array} edges - 边数组，每个元素需包含 source 和 target 属性
         * @returns {Array} 按箭头方向排序后的节点 id 数组
         */
        function topologicalSort(nodes, edges) {
            // 构建邻接表表示的有向图
            const adjacencyList = new Map();
            const inDegree = new Map();

            // 初始化邻接表和入度表
            nodes.forEach(node => {
                const nodeId = node.id;
                adjacencyList.set(nodeId, []);
                inDegree.set(nodeId, 0);
            });

            // 构建邻接表和计算入度
            edges.forEach(edge => {
                const sourceId = edge.getSourceCellId();
                const targetId = edge.getTargetCellId();

                if (sourceId && targetId && adjacencyList.has(sourceId) && adjacencyList.has(targetId)) {
                    adjacencyList.get(sourceId).push(targetId);
                    inDegree.set(targetId, inDegree.get(targetId) + 1);
                }
            });

            // 拓扑排序
            const queue = [];
            const sortedNodes = [];

            // 将入度为0的节点加入队列
            inDegree.forEach((degree, nodeId) => {
                if (degree === 0) {
                    queue.push(nodeId);
                }
            });

            // 执行拓扑排序
            while (queue.length > 0) {
                const currentId = queue.shift();
                sortedNodes.push(currentId);

                // 更新相邻节点的入度
                const neighbors = adjacencyList.get(currentId);
                neighbors.forEach(neighborId => {
                    const newInDegree = inDegree.get(neighborId) - 1;
                    inDegree.set(neighborId, newInDegree);

                    if (newInDegree === 0) {
                        queue.push(neighborId);
                    }
                });
            }

            // 正确识别孤立节点：既不是任何边的源节点，也不是任何边的目标节点
            const allConnectedNodes = new Set();
            // 收集所有参与连接的节点
            edges.forEach(edge => {
                const sourceId = edge.getSourceCellId();
                const targetId = edge.getTargetCellId();

                if (sourceId) allConnectedNodes.add(sourceId);
                if (targetId) allConnectedNodes.add(targetId);
            });

            // 孤立节点是那些没有参与任何连接的节点
            const isolatedNodes = nodes
                .filter(node => !allConnectedNodes.has(node.id))
                .map(node => node.id);

            // 合并排序结果：已连接节点 + 孤立节点
            const finalOrder = [...allConnectedNodes, ...isolatedNodes];

            // 根据排序结果设置节点层级
            finalOrder.forEach((nodeId, index) => {
                const node = graph.getCellById(nodeId);
                if (node) {
                    node.setZIndex(index);
                }
            });

            return finalOrder;
        }

        // 监听自定义事件
        function setup() {
            // 画布比例尺变化
            graph.on('scale', () => {
                setCurrentZoom(graph.zoom());
            });

            // 点击画布空白区
            graph.on('blank:click', () => {
                cancelSelectedNodeAll(graph);
                // 点击画布空白处时，清空选中状态
                graph.cleanSelection();
            });

            // 节点，鼠标点击节点
            graph.on('node:click', ({ node }) => {
                cancelSelectedNodeAll(graph);
                node.setData({
                    isSelected: true,
                });
                // 将其设置为选中状态
                graph.select(node);
            });

            // 节点，鼠标进入节点
            graph.on('node:mouseenter', ({ node }) => {
                const ports = node.getPorts();
                ports.forEach(port => {
                    const portId = port.id;
                    const group = port.group;

                    if (group === 'left') {
                        // 左侧连接桩高亮：修改圆形的填充色和边框色
                        node.setPortProp(portId, 'attrs/circle/r', 5);
                    } else if (group === 'right') {
                        // 右侧连接桩：隐藏圆形，显示加号文本
                        node.setPortProp(portId, 'attrs/circle/r', 5);
                        node.setPortProp(portId, 'attrs/circle/stroke', colorPrimary);
                        node.setPortProp(portId, 'attrs/circle/fill', colorPrimary);
                        // node.setPortProp(portId, 'attrs/text/visibility', 'visible');
                    }
                });
            });

            // 节点，鼠标离开节点
            graph.on('node:mouseleave', ({ node }) => {
                const ports = node.getPorts();
                ports.forEach(port => {
                    const portId = port.id;
                    const group = port.group;

                    if (group === 'left') {
                        // 左侧连接桩高亮：修改圆形的填充色和边框色
                        node.setPortProp(portId, 'attrs/circle/r', 4);
                    } else if (group === 'right') {
                        // 恢复右侧连接桩原始样式：圆形白色填充，隐藏加号
                        node.setPortProp(portId, 'attrs/circle/r', 4);
                        node.setPortProp(portId, 'attrs/circle/stroke', colorPrimary);
                        node.setPortProp(portId, 'attrs/circle/fill', '#fff');
                        // node.setPortProp(portId, 'attrs/text/visibility', 'hidden');
                    }
                });
            });

            // 连接线，连接成功
            graph.on('edge:connected', () => {
                // 获取所有节点和边
                const nodes = graph.getNodes();
                const edges = graph.getEdges();
                // 根据箭头排序
                topologicalSort(nodes, edges);
            });
            // 连接线，删除成功
            graph.on('edge:removed', () => {
                // console.log('edge:removed');
            });

            // 连接线，当鼠标进入边时，添加删除按钮
            graph.on('edge:mouseenter', ({ cell }) => {
                cell.addTools([
                    {
                        name: 'button-remove',
                        args: { distance: -50 },
                    },
                ]);
            });

            // 连接线，当鼠标离开边时，移除删除按钮
            graph.on('edge:mouseleave', ({ cell }) => {
                cell.removeTools(); // 移除边上所有的工具
            });
        }

        setGraph(graph);
        setDnd(dnd);

        setup();

        // 组件卸载时，移除监听
        return () => {
            if (graph) {
                graph.dispose();
            }
        };

    }, []);

    // 监听画布缩放
    useEffect(() => {
        if (!graph) return;
        graph.resize(isFullScreen ? winWidth : winWidth - 240);
    }, [isFullScreen]);

    // 监听选中节点
    useEffect(() => {
        if (!graph) return;
        graph.resize(isFullScreen ? winWidth : winWidth - 240);
    }, [currentNodeId]);


    // 初始化应用信息
    useEffect(() => {
        const getAppInfo = () => {
            const params = {
                rss: 'info',
                app_id: props.appId,
            };
            $.ajax({
                url: `${CNF.api}app/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setAppInfo(data.dat[0]);
                        } else {
                            setAppInfo(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        getAppInfo();
    }, []);

    // 初始化应用配置
    useEffect(() => {
        if (graph) {
            if (appInfo?.app_config) {
                const serialized = JSON.parse(appInfo.app_config);
                // 序列化并加载配置
                deserializeGraph(graph, serialized);
            } else {
                // 创建开始与结束节点
                graph.addNode({
                    id: GenerateNodeId(CNF.nodeConfig.start.key),
                    shape: 'app-drop-node',
                    data: {
                        ...CNF.nodeConfig.start,
                        isSelected: false,
                    },
                    position: { x: 240, y: 180 },
                    ports: {
                        items: [
                            {
                                group: 'right',
                            },
                        ],
                    },
                });
                graph.addNode({
                    id: GenerateNodeId(CNF.nodeConfig.end.key),
                    shape: 'app-drop-node',
                    data: { ...CNF.nodeConfig.end, isSelected: false },
                    position: { x: winWidth - 720, y: winHeight - 320 },
                    ports: {
                        items: [
                            {
                                group: 'left',
                            },
                        ],
                    },
                });
            }

        }
    }, [appInfo]);

    // 保存应用配置
    const save = () => {
        // 序列化画布数据
        const serialized = serializeGraph(graph);
        const jsonStr = JSON.stringify(serialized);

        // 保存画布信息
        $.ajax({
            url: `${CNF.api}app/infos/${appInfo.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'app_config': jsonStr,
                'description': '修改应用配置',
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return <>
        {/* --start-- 标题功能区 */}
        <Flex style={{
            alignItems: 'center',
            borderBottom: `1px solid ${colorBgSolid}`,
            height: CNF.menuHeight,
            paddingLeft: CNF.basePadding,
            paddingRight: CNF.basePadding,
            background: colorBgContent,
        }}>
            {contextHolder}
            <div style={{ minWidth: 360, maxWidth: 360, }}>
                <Space>
                    <Button color='default' variant='text' icon={<ArrowLeftOutlined />} style={{ border: `1px solid ${colorBgSolid}` }}
                        onClick={() => {
                            // 返回应用管理
                            props.setUri(CNF.menuItems[0].submenu[1].uri);
                        }}
                    />
                    <Tooltip title={appInfo?.app_name}><Title ellipsis level={5} style={{ color: colorTextBase, margin: 0, width: 120, }}>{appInfo?.app_name}</Title></Tooltip>
                    <Button color='default' variant='filled' size='small' icon={<FileTextOutlined />}>草稿</Button>
                    <Text style={{ color: colorTextBase, fontSize: fontSizeSM, }}>更新于：{appInfo?.update_time.split(' ')[1]}</Text>
                </Space>
            </div>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                <Space>
                    <Button color='default' variant='text' style={{ border: `1px solid ${colorBgSolid}` }}>测试</Button>
                    <Tooltip title='手动保存当前画布'><Button color='default' variant='text' icon={<SaveOutlined />} style={{ border: `1px solid ${colorBgSolid}` }} onClick={() => {
                        // 保存
                        save();
                    }} /></Tooltip>
                    {
                        props.isDarkMode ?
                            <Button color='primary' style={{ border: `1px solid ${colorPrimary}` }} variant='filled' onClick={renderAppReleaseEnity}>发布</Button>
                            :
                            <Button color='primary' variant='solid' onClick={renderAppReleaseEnity}>发布</Button>
                    }

                </Space>
            </div>
        </Flex>
        {/* --end-- 标题功能区 */}

        <Flex style={{ height: winHeight - CNF.menuHeight }}>
            <div style={{
                background: colorBgContent,
                width: 204,
                borderRight: `1px solid ${colorBgSolid}`,
                padding: CNF.basePadding,
                display: isFullScreen ? 'none' : 'block',
            }}>
                <Space orientation='vertical' size={18}>
                    <Flex>
                        <Text style={{ width: 180, fontSize: fontSizeLG }} strong>节点管理</Text>
                        <Button color='default' variant='text' size='small' style={{
                            color: colorTextBase,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                            onClick={() => {
                                setIsFullScreen(true);
                            }}
                        ><MenuFoldOutlined /></Button>
                    </Flex>
                    <div>
                        <Text style={{ color: colorTextBase, fontSize: fontSizeSM }}>基础</Text>
                        <div data-type='llm' onMouseDown={startDrag}>
                            <Button color='default' variant='text' style={{ paddingLeft: 2, width: 204, justifyContent: 'start', color: colorTextBase }} >
                                <Avatar size='small' shape='square' icon={CNF.nodeConfig['llm'].icon} style={{ background: CNF.nodeConfig['llm'].theme }} />{CNF.nodeConfig['llm'].title}
                            </Button>
                        </div>
                    </div>
                    <div>
                        <Text style={{ color: colorTextBase, fontSize: fontSizeSM }}>工具</Text>
                        <div data-type='mcp' onMouseDown={startDrag}>
                            <Button style={{ paddingLeft: 2, width: 204, justifyContent: 'start', color: colorTextBase }} color='default' variant='text'>
                                <Avatar size='small' shape='square' icon={CNF.nodeConfig['mcp'].icon} style={{ background: CNF.nodeConfig['mcp'].theme }} />{CNF.nodeConfig['mcp'].title}
                            </Button>
                        </div>
                        <div data-type='api' onMouseDown={startDrag}>
                            <Button style={{ paddingLeft: 2, width: 204, justifyContent: 'start', color: colorTextBase }} color='default' variant='text'>
                                <Avatar size='small' shape='square' icon={CNF.nodeConfig['api'].icon} style={{ background: CNF.nodeConfig['api'].theme }} />{CNF.nodeConfig['api'].title}
                            </Button>
                        </div>
                    </div>
                </Space>
            </div>
            <div ref={graphRef}></div>
        </Flex>

        {/* --start-- 收起菜单按钮 */}
        <>
            {
                isFullScreen ? <FloatButton shape='square' size='small' icon={<MenuUnfoldOutlined style={{ color: colorTextBase, fontSize: fontSizeSM, }} />}
                    style={{
                        insetInlineStart: CNF.basePadding, top: CNF.menuHeight + CNF.basePadding,
                        height: 24,
                        border: `1px solid ${colorBgSolid}`
                    }}
                    onClick={() => {
                        setIsFullScreen(false);
                    }}
                /> : null
            }
        </>
        {/* --start-- 收起菜单按钮 */}

        {/* --start-- 画布功能按钮 */}
        <div style={{
            position: 'absolute',
            zIndex: 100,
            left: CNF.basePadding + (isFullScreen ? 0 : 240), bottom: CNF.basePadding,
            border: `1px solid ${colorBgSolid}`,
            padding: CNF.basePadding / 2,
            borderRadius: 8,
            background: colorBgContent,
            boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.08)',
        }}
        >
            <Space size={0}>
                <Button color='default' variant='text' size='small' icon={<ZoomOutOutlined />} onClick={() => {
                    // 最小缩放
                    if (currentZoom <= 0.1) {
                        return;
                    }
                    graph.zoomTo(currentZoom - 0.25);
                    setCurrentZoom(currentZoom - 0.25);
                }} />
                <Dropdown
                    menu={{
                        items: [
                            {
                                key: 2,
                                label: '200%',
                            },
                            {
                                key: 1.5,
                                label: '150%',
                            },
                            {
                                key: 1,
                                label: '100%',
                            },
                            {
                                key: 0.5,
                                label: '50%',
                            },
                            {
                                key: '自适应视图',
                                label: '自适应视图',
                            },
                        ], onClick: ({ key }) => {
                            setCurrentZoom(key);
                            key === '自适应视图' ? graph.zoomToFit() : graph.zoomTo(key);
                        }
                    }}
                    placement='top'
                    trigger={['click']}
                    styles={{
                        root: {
                            bottom: 68,
                        },
                    }}
                ><Button color='default' variant='text' size='small' style={{ width: 48, }}>{(currentZoom * 100).toFixed(0)}%</Button>
                </Dropdown>
                <Button color='default' variant='text' size='small' icon={<ZoomInOutlined />} onClick={() => {
                    // 最大缩放
                    if (currentZoom >= 2) {
                        return;
                    }
                    graph.zoomTo(currentZoom + 0.25);
                    setCurrentZoom(currentZoom + 0.25);
                }} />
                <Divider orientation='vertical' />
                <Tooltip title='自适应视图' placement='top'>
                    <Button color='default' variant='text' size='small' icon={<ZoomFitIcon />} onClick={() => {
                        // 自适应视图
                        graph.zoomToFit({ maxScale: 1 });
                    }} />
                </Tooltip>
            </Space>
        </div>
        {/* --end-- 画布功能按钮 */}

    </>
}

export default AppWorkFlow;